<script>
import AppSvgSymbol from "@escavador/global-components/AppSvgSymbol";
import AppCalendar from "../../../_painel_admin/components/global/AppCalendar/index.vue";
import Loading from "../../monitoramentos/Loading";
import format from "date-fns/format";
import parseISO from "date-fns/esm/fp/parseISO/index.js";
import pt from "date-fns/locale/pt";
import {isAfter} from "date-fns";
import latenize from "../../../../user/js/utils/latenize";

export default {
  name: "OabProcessosFormModal.vue",
  components: {
    AppSvgSymbol,
    AppCalendar,
    Loading
  },
  props: {
    visible: {
      required: true,
      type: Boolean
    },
    filtros: {
      required: true,
      type: Object
    },
    tribunais: {
      required: true,
      type: Array
    },
  },
  watch: {
    visible (next) {
      if (next) this.estadoInicial();
    }
  },
  data() {
    return {
      closeButton: false,
      submited:false,
      listaTribunais: [],
      dateFormat: "dd MMM yyyy",
      searchTribunal: "",
      filtros_: {
        tribunais: [],
        dateOne: "",
        dateTwo: "",
        oab_tipo: null,
        ordem: 'desc',
        status: null,
      }
    };
  },
  computed: {
    mudouFiltro() {
      const props = Object.keys(this.filtros_);

      for (const prop of props) {
        if (this.filtros_[prop] !== this.filtros[prop]) {
          return true;
        }
      }

      return false;
    },
    endDate() {
      return new Date();
    },
    tribunaisFiltrados() {
      return this.tribunais.filter((option) =>
        this.optionSearch(option, this.searchTribunal)
      )
    },
    tribunaisLabel() {
      if (this.filtros_.tribunais.length) {
        return this.filtros_.tribunais.slice(0, 5).join(', ') + (this.filtros_.tribunais.length > 5 ? '...' : '')
      } else {
        return "Todos"
      }
    }
  },
  methods: {
    optionSearch(option, term) {
      return term
        ? latenize(option?.nome + " " + option?.sigla || "").includes(latenize(term))
        : option;
    },
    estadoInicial() {
      Object.assign(this.filtros_, this.filtros);
    },
    dataInvalida(){
      if (this.filtros_.dateOne.length || this.filtros_.dateTwo.length) {
        return isAfter(new Date(this.filtros_.dateOne), new Date(this.filtros_.dateTwo))
      }
      return false;
    },
    changeStyle(nomeRef){
      let popover = this.$refs[nomeRef].$children[0].$refs['popover'];
      popover.style.zIndex = "9999";
    },
    limparTodosFiltros() {
      this.filtros_.tribunais = [];
      this.filtros_.dateOne = "";
      this.filtros_.dateTwo = "";
      this.filtros_.status = null;

      this.filtros_.oab_tipo = null;
      this.filtros_.ordem = 'desc';
    },
    limparFiltro(prop){
      if (prop === 'date') {
        this.filtros_.dateOne = "";
        this.filtros_.dateTwo = "";
      }

      if (prop === 'tribunais') {
        this.filtros_.tribunais = [];
      }

      if (prop === 'ordem') {
        this.filtros_.ordem = 'desc';
      }

      if (prop === 'oab_tipo') {
        this.filtros_.oab_tipo = null;
      }

      if (prop === 'status') {
        this.filtros_.status = null;
      }
    },
    salvarFiltro() {
      this.$emit("addFiltro", this.filtros_);
      this.$refs.modal?.closeModal();
    },
    closeModal() {
      this.$emit("closeModal");
    },
    addStartDate($event) {
      this.filtros_.dateOne = ($event && $event.sql) || "";
    },
    addEndDate($event) {
      this.filtros_.dateTwo = ($event && $event.sql) || "";
    },
    closeDropdown(nomeRef) {
      this.$refs[nomeRef].hide();
    },
    formatDates(date) {
      if (date) {
        return  format(parseISO(date), this.dateFormat, {
          locale: pt,
        });
      }
    },
  }
}
</script>

<template>
  <div>
    <modal
      v-if="visible"
      ref="modal"
      size="small"
      :hideCloseButton="closeButton"
      :showControls="false"
      @close-modal="closeModal"
    >
      <div slot="header">
        Filtros
      </div>
      <div class="container" slot="content">
        <div class="form-box -full -left">

          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Status do processo</label>
              <button class="clean-button" @click="limparFiltro('status')">Limpar</button>
            </div>

            <select
              name="selectStatus"
              v-model="filtros_.status"
              class="field px-3 rounded-md text-sm"
            >
              <option :value="null">
                Todos
              </option>

              <option :value="true">
                Processo ativo
              </option>

              <option :value="false">
                Processo inativo
              </option>
            </select>
          </div>


          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Tipo da OAB</label>
              <button class="clean-button" @click="limparFiltro('oab_tipo')">Limpar</button>
            </div>

            <select
              name="selectStatus"
              v-model="filtros_.oab_tipo"
              class="field px-3 rounded-md text-sm"
            >
              <option :value="null">
                Todos
              </option>

              <option value="ADVOGADO">
                Advogado
              </option>

              <option value="SUPLEMENTAR">
                Suplementar
              </option>

              <option value="ESTAGIARIO">
                Estagiário
              </option>

              <option value="CONSULTOR_ESTRANGEIRO">
                Consultor Estrangeiro
              </option>
            </select>
          </div>

          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Ordem da resposta <small>(iníco do processo)</small></label>
              <button class="clean-button" @click="limparFiltro('ordem')">Limpar</button>
            </div>

            <div class="field-content-radio">
              <div class="filtro-radio">
                <input type="radio" id="ordem_crescente" name="ordem_resposta"
                       value="asc" v-model="filtros_.ordem">
                <label for="ordem_crescente"  class="font-medium text-sm">Crescente</label>
              </div>

              <div class="filtro-radio">
                <input type="radio" id="ordem_decrescente" name="ordem_resposta"
                       value="desc" v-model="filtros_.ordem" checked>
                <label for="ordem_decrescente"  class="font-medium text-sm">Decrescente</label>
              </div>
            </div>
          </div>

          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Tribunais</label>
              <button class="clean-button" @click="limparFiltro('tribunais')">Limpar</button>
            </div>
            <AppDropdown
              ref="trDropdown"
              :target="{ attrs: { type: 'button' } }"
              :theme="{ target: ['border', 'w-full', '!justify-start', 'font-medium', ' text-sm'] }"
              :v-popover="{ placement: 'top'}"
              @show="changeStyle('trDropdown')"
            >
              <template #target>
                {{ tribunaisLabel }}
              </template>
              <template #popover>
                <div slot="popover">
                  <div class="border-b flex flex-nowrap">
                    <div class="py-4 pl-4 bg-white">
                      <AppSvgSymbol name="@escavador/search" size="18" />
                    </div>
                    <input
                      class="p-4 border-none outline-0 w-full text-sm"
                      type="text"
                      v-model="searchTribunal"
                      placeholder="Pesquisar"
                    />
                  </div>

                  <div class="filtro-content">
                    <ul class="w-full border-gray-300 z-10 rounded-lg bg-white overflow-y-auto max-h-[400px] max-w-[300px]">
                      <li v-for="item in tribunaisFiltrados"
                          class="flex w-full filtro-checkbox"
                      >
                        <input type="checkbox"
                               :id="item.id"
                               :value="item.sigla"
                               v-model="filtros_.tribunais"
                        />
                        <label :for="item.id">{{ item.nome }}
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </AppDropdown>
          </div>

          <div>
            <div>
              <div class="label-filter">
                <p class="font-medium text-sm m-0">Início do processo</p>
                <button class="clean-button" @click="limparFiltro('date')">Limpar</button>
              </div>
              <small
                v-if="dataInvalida()"
                class="form-error"
              >
                A data máxima é anterior à data mínima.
              </small>
            </div>
            <div class="field-box">
              <label class="font-medium text-sm">Depois de</label>
              <AppDropdown
                ref="dateDropdownPlayStart"
                :target="{ attrs: { type: 'button' } }"
                :theme="{ target: ['border', 'w-full', '!justify-start', 'font-medium', ' text-sm'] }"
                @show="changeStyle('dateDropdownPlayStart')"
              >
                <template #target>
                  {{ formatDates(filtros_.dateOne) || "Selecionar data" }}
                </template>
                <template #popover>
                  <AppCalendar
                    style="width: 100% !important;"
                    :use-controls="true"
                    :show-select-year="true"
                    :finalDate="endDate"
                    :positive-control="{text: 'Selecionar'}"
                    mode="single"
                    @select-date="addStartDate"
                    @date-confirmation="closeDropdown('dateDropdownPlayStart')"
                  />
                </template>
              </AppDropdown>
            </div>

            <div class="field-box">
              <label class="font-medium text-sm">Antes de</label>
              <AppDropdown
                ref="dateDropdownPlayEnd"
                :target="{ attrs: { type: 'button' } }"
                :theme="{ target: ['border', 'w-full', '!justify-start', 'font-medium', ' text-sm'] }"
                @show="changeStyle('dateDropdownPlayEnd')"
              >
                <template #target>
                  {{ formatDates(filtros_.dateTwo) || "Selecionar data" }}
                </template>
                <template #popover>
                  <AppCalendar
                    style="width: 100% !important;"
                    :use-controls="true"
                    :show-select-year="true"
                    :finalDate="endDate"
                    :positive-control="{text: 'Selecionar'}"
                    mode="single"
                    @select-date="addEndDate"
                    @date-confirmation="closeDropdown('dateDropdownPlayEnd')"
                  />
                </template>
              </AppDropdown>
            </div>

          </div>

          <div class="div-buttons">
            <button class="btn -left -color -clear -medium"
                    @click="limparTodosFiltros">
              <b>Limpar filtros</b>
            </button>

            <button class="btn -right"
                    :disabled="!mudouFiltro || dataInvalida()"
                    @click="salvarFiltro">
              <b>Salvar</b>
            </button>
          </div>
        </div>

      </div>
      <div slot="footer"></div>
    </modal>
    <Loading></Loading>
  </div>
</template>

<style scoped lang="stylus">
.container
  width 300px

.form-box.-full
  max-width 296px

  @media (max-width: 768px)
    max-width none

.form-box
  display flex
  flex-direction column
  gap 20px

.div-buttons
  padding-top 10px

.label-filter
  align-items baseline
  display flex
  justify-content space-between
  width 100%

.clean-button
  color #AFAEBA
  cursor pointer
  font-size 12px
  font-weight 600

.form-error
  color #DC6C51

input[type="checkbox"], input[type="radio"]
  max-width 20px
  max-height 20px

.filtro-checkbox
  display flex
  align-items: center;
  padding: 4px 14px;
  gap: 12px;
  font-size: 14px;

.filtro-checkbox:hover
  background-color rgba(229, 231, 235, 1);

ul
  margin 0

.filtro-content
  height 300px


.filtro-radio
  display flex
  align-items center
  gap 6px

.field-content-radio
  display flex
  gap 20px
</style>
